// ChatBot.jsx
import React, { useState, useRef, useEffect } from "react";

import * as chatApi from "../lib/chat";

import { parseMarkdown } from "../lib/utilities";

const ChatBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      text: "Hello there! I'm your friendly neighborhood Book Assistant! Ask me about any of Chris's books!",
      sender: "bot",
    },
  ]);
  const [inputValue, setInputValue] = useState("");
  const [activeTab, setActiveTab] = useState("tab1");
  const messagesEndRef = useRef(null);

  // Auto-scroll to the bottom of the chat
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!inputValue.trim()) return;
    sendChatMessage(inputValue);
  };

  const sendChatMessage = (input) => {
    setActiveTab("tab1");
    // Add user message
    const newMessages = [...messages, { text: input, sender: "user" }];
    setMessages(newMessages);
    setInputValue("");
    setActiveTab("tab1");

    // Process and add bot response
    setTimeout(() => {
      const botResponse = chatApi.processMessage(input);
      setMessages([...newMessages, { text: botResponse, sender: "bot" }]);
    }, 600); // Small delay to make it feel more natural
  };

  const onInstantAnswer = (question) => {
    sendChatMessage(question);
  };

  const cannedQuestions = [
    "Where can I purchase these books?",
    "In what formats are the books available?",
    "What is Chris's latest book?",
    "When is the next book coming out?",
    "Is Chris on social media (eg, Facebook)?",
    "Where can I leave a review?",
    "I have another question not listed here...",
  ];

  return (
    <div className="chat-bot-container">
      {/* Chat button */}
      <button className="chat-bot-button" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? "✕" : "💬 Chat"}
      </button>

      {/* Chat window */}
      {isOpen && (
        <div className="chat-bot-window">
          <div className="tabs-container">
            {/* Tab Buttons */}
            <div className="tab-buttons">
              <button
                className={`tab-button ${activeTab === "tab1" ? "active" : ""}`}
                onClick={() => setActiveTab("tab1")}
              >
                Chat
              </button>
              <button
                className={`tab-button ${activeTab === "tab2" ? "active" : ""}`}
                onClick={() => setActiveTab("tab2")}
              >
                Quick Answers
              </button>
            </div>
            {/* Tab Content */}
            <div className="tab-content">
              {activeTab === "tab1" && (
                <div>
                  <div className="chat-bot-messages">
                    {messages.map((message, index) => (
                      <div key={index} className={`message ${message.sender}`}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: parseMarkdown(message.text),
                          }}
                        />
                      </div>
                    ))}
                    <div ref={messagesEndRef} />
                  </div>
                  <form onSubmit={handleSubmit} className="chat-bot-input-form">
                    <input
                      type="text"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      placeholder="Ask me about the books..."
                      className="chat-bot-input"
                    />
                    <button type="submit" className="chat-bot-send">
                      Send
                    </button>
                  </form>
                </div>
              )}
              {activeTab === "tab2" && (
                <div className="instant-answers">
                  {cannedQuestions.map((q) => {
                    return (
                      <button
                        className="answer-item"
                        onClick={() => onInstantAnswer(q)}
                      >
                        {q}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatBot;
